import Helpers from "../Helpers";
import type Entry from "./Entry";

export class CatDB 
{
    id!: string;
    timestamp!:number;
    id_user!:string;
    name!: string;
    type:string="";// type - new prop, to have type of category, in spite of name- so for instance if the name gets set to bathroom in chinese, the type can still be of bathroom, so can display custom UI for it

    date_updated!: Date;

    color_bg!: string;
    color_txt!: string;
    icon!: string;
    
    
    // constructor(id:number, date_updated:Date, name:string, bg_color:string, txt_color:string, icon:string)
    constructor(obj:any)
    {
        //this allows us to copy all the variables/ proporties from a generic object to our current object (without haviung to do it manually, one by one)
        // Object.assign(this, obj); //copies everythign over, even if we don't have this property, which adds new properties we don't want

        //fix to only copy properties we actually have:
        Helpers.CopyObject(this, obj);

        //generate timestamp from date
        if(!this.timestamp&&this.date_updated)
            this.timestamp=this.date_updated.getTime();
        // this.id=id;
        // this.date_updated=date_updated;
        // this.name=name;
        // this.bg_color=bg_color;
        // this.txt_color=txt_color;
        // this.icon=icon;
    }

    //for if a cat needs to be created, but might not have default options
    SetDefaults()
    {
        if(!this.date_updated)
            this.date_updated=new Date();
        if(!this.timestamp)
            this.timestamp=this.date_updated.getTime();
        if(!this.name)
            this.name="A New category";
        if(!this.color_bg)
            this.color_bg="rgba(128,128,128,1)";
        if(!this.color_txt)
            this.color_txt="rgba(255,255,255,1)";
        if(!this.icon)
            this.icon="paragliding";

        return this;
    }
}

//for the type of data that will be in a category- both one I create, and new ones people create
export default class CategoryData extends CatDB
{
    //have to do question mark to not have to explicitly state values before being created/ requires constructor to set all vars
    // id!:number;
    // date_updated!:Date;
    // name!:string;
    // bg_color!:string;
    // txt_color!:string;
    // icon!:string;
    entries:Array<Entry>;
    // entries:Array<Entry>;

    //constructor(id:number, date_updated?:Date, name?:string, bg_color?:string, txt_color?:string, icon?:string)
    constructor(obj:any)
    {
        super({});//if we actually pass the object using super, it will only copy over the variables on the parent class- not the current class, so have to do it again
        // Object.assign(this, obj);
        Helpers.CopyObject(this, obj);
        // this.id = id;

        if(this.date_updated==undefined)
            this.date_updated = new Date();

        //generate timestamp from date
        if(!this.timestamp)
            this.timestamp=this.date_updated.getTime();

        // this.date_updated = date_updated;
        // console.log("CategoryData: "+this.name+" this bg color: ", this.color_bg)

        this.name = this.name||"name";
        this.color_bg = this.color_bg||"red";
        this.color_txt = this.color_txt||"white";
        this.icon = this.icon||"house";
        this.entries = new Array<Entry>();
    }
    Assign(obj:any)
    {
        Object.assign(this, obj);
    }

}